import { render, staticRenderFns } from "./InputInboxNeedRevision.vue?vue&type=template&id=b20b6c6c&"
import script from "./InputInboxNeedRevision.vue?vue&type=script&lang=js&"
export * from "./InputInboxNeedRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports